<template>
    <div class="main">
        <admin-navigation></admin-navigation>
        <div class="content-area" v-if="emptyState">
            <div class="page-header">
                <div class="page-details">
                    <h2>Admins</h2>
                    <ul class="breadcrumbs">
                        <li>
                            <router-link :to="'/dashboard'">Dashboard</router-link>
                        </li>
                        <li>
                            <router-link :to="'/admins'" class="current">Admins</router-link>
                        </li>
                    </ul>
                </div>
                <div class="actions" v-show="showCreateAdmins">
                    <button class="btn btn-primary" @click.prevent="createAdmin">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.99984 4.16666V15.8333M4.1665 9.99999H15.8332" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Add Admin
                    </button>
                </div>
            </div>
            <div class="section mt-3 no-bg">
                <data-table :ajax="adminAjax" :columns="adminColumns" :order="0"></data-table>
            </div>
        </div>
        <div class="content-area" v-if="!emptyState">
            <div class="page-header">
                <div class="page-details">
                    <h2>Admins</h2>
                    <ul class="breadcrumbs">
                        <li>
                            <router-link :to="'/dashboard'">Dashboard</router-link>
                        </li>
                        <li>
                            <router-link :to="'/admins'" class="current">Admins</router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="section no-bg">
                <div class="empty-state mt-5">
                    <img :src="base_url + '/admin/img/noEmployees.svg'" />
                    <h5>No Admin</h5>
                    <p>
                        Looks like there are no users records <br />
                        Kindly Create one to show data.
                    </p>
                    <a href="#" class="btn btn-primary" @click.prevent="createAdmin"> + Add New Admin</a>
                </div>
            </div>
        </div>
        <div class="modal fade" id="manageAdminModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Create New Admin</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form-error :errors="errors"></form-error>
                    <form action="#" id="manageAdminForm" @submit.prevent="storeAdmin">
                        <div class="modal-body">
                            <div class="form-group">
                                <label for="">Upload Image</label>
                                <input type="file" class="form-control" name="image" required />
                            </div>
                            <div class="form-group">
                                <label for="">First Name</label>
                                <input type="text" class="form-control" name="first_name" v-model="adminForm.first_name" required />
                            </div>
                            <div class="form-group">
                                <label for="">Last Name</label>
                                <input type="text" class="form-control" name="last_name" v-model="adminForm.last_name" required />
                            </div>
                            <div class="form-group">
                                <label for="">Email ID</label>
                                <input type="email" class="form-control" name="email" v-model="adminForm.email" required />
                            </div>
                            <div class="form-group">
                                <label for="">Phone Number</label>
                                <input type="text" class="form-control" name="phone" v-model="adminForm.phone" required />
                            </div>
                            <div class="form-group">
                                <label for="">Settings</label>
                                <div class="form-check">
                                    <input class="form-check-input" name="status" type="checkbox" value="1" v-model="adminForm.status" id="status" />
                                    <label class="form-check-label" for="status"> Active </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" name="is_site_manager" type="checkbox" v-model="adminForm.is_site_manager" value="1" id="is_site_manager" />
                                    <label class="form-check-label" for="is_site_manager"> Site Manager </label>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="">Password</label>
                                <input type="password" class="form-control" name="password" v-model="adminForm.password" required />
                            </div>
                            <div class="form-group">
                                <label for="">Confirm Password</label>
                                <input type="password" class="form-control" name="password_confirmation" v-model="adminForm.password_confirmation" required />
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-primary">Save</button>
                            <button type="button" class="btn" data-bs-dismiss="modal">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="modal fade" id="manageAdminModalUpdate" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Update Admin</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form-error :errors="errors"></form-error>
                    <form action="#" id="manageAdminFormUpdate" @submit.prevent="updateAdmin(admin_id)" enctype="multipart/form-data">
                        <div class="modal-body">
                            <div class="form-group">
                                <label for="">Uploaded Image</label>
                                <img :src="adminForm.image" class="w-25" />
                            </div>
                            <div class="form-group">
                                <label for="">Upload new image</label>
                                <input type="file" class="form-control" name="image" id="updated_image" />
                            </div>
                            <div class="form-group">
                                <label for="">First Name</label>
                                <input type="text" class="form-control" name="first_name" v-model="adminForm.first_name" required />
                            </div>
                            <div class="form-group">
                                <label for="">Last Name</label>
                                <input type="text" class="form-control" name="last_name" v-model="adminForm.last_name" required />
                            </div>
                            <div class="form-group">
                                <label for="">Email ID</label>
                                <input type="email" class="form-control" name="email" v-model="adminForm.email" required readonly="" />
                            </div>
                            <div class="form-group">
                                <label for="">Phone Number</label>
                                <input type="text" class="form-control" name="phone" v-model="adminForm.phone" required />
                            </div>
                            <div class="form-group">
                                <label for="">Settings</label>
                                <div class="form-check">
                                    <input class="form-check-input" name="status" type="checkbox" v-model="adminForm.status" value="1" id="status" />
                                    <label class="form-check-label" for="status"> Active </label>
                                </div>
                                <div class="form-check" v-if="this.$root.adminInfo.id != this.admin_id">
                                    <input class="form-check-input" name="is_site_manager" type="checkbox" v-model="adminForm.is_site_manager" value="1" id="is_site_manager" />
                                    <label class="form-check-label" for="is_site_manager"> Site Manager </label>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-primary">Save</button>
                            <button type="button" class="btn" data-bs-dismiss="modal">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="modal fade" id="manageLocationsModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel1">Edit Locations</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="locations__listing">
                            <div class="tags__entry" v-for="location in locations">
                                <h6>{{ location.name }}</h6>
                                <div class="switch" :data-active="location.exists" @click="switchLocation(location)">
                                    <input type="checkbox" :value="location.id" name="locations[]" />
                                    <div class="switch__wrapper">
                                        <div class="switch__toggle"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-info" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import FormError from './FormError.vue';
export default {
    data() {
        return {
            showCreateAdmins: true,
            emptyState: false,
            editMode: false,
            adminAjax: {},
            adminColumns: [],
            search: "",
            tags: {},
            locations: [],
            table_search: false,
            admin_id: null,
            adminForm: new Form({
                first_name: '',
                last_name: '',
                email: '',
                status: 1,
                phone: '',
                image: "",
                is_site_manager: 0
            }),
            errors: false
        }
    },
    created() {
        this.getAllAdmins();
        this.loadDataTableDetails();
        this.viewPage();
    },
    methods: {
        getAllAdmins() {
            axios.get("/api/admin/admins").then(response => {
                if (Object.keys(response.data.data.admins).length > 0) { // Check if there are employees or not
                    this.emptyState = true;
                } else {
                    this.emptyState = false;
                }
                this.showCreateAdmins = response.data.data.creating_admins_availability;
            }).catch(error => {
                this.$root.erroHandler(error);
            });
        },
        loadDataTableDetails() {
            let adminInfo = this.$root.adminInfo;
            this.adminAjax = {
                url: `/api/admin/admins/grid`,
                method: "GET",
                headers: {
                    'X-Api-Key': `Bearer ${localStorage.getItem("admin_auth")}`
                },
            };

            this.adminColumns = [{
                    name: 'User Details',
                    data: null,
                    render(data, type, row, meta) {
                        let html = `<a href='javascript:;' class="user-datatable__wrapper view-admin-details" data-id="${data.id}">
                                    <img class="user-datatable__img" src="${data.full_image_path}" />
                                    <div class="user-datatable__details">
                                        <h6>${data.full_name}</h6>
                                        <p>${data.phone} <span class="text-success">${data.admin_type}</span></p>
                                    </div>
                                </a>`;
                        return html;
                    },
                },
                { name: 'Email ID', data: 'email', orderable: true, searchable: true },
                { name: 'Mobile No.', data: 'phone', orderable: true, searchable: true },
                { name: 'Status', data: 'status', orderable: true, searchable: true },
                {
                    name: 'Actions',
                    data: null,
                    render(data, type, row, meta) {
                        let site_manager_url = "";
                        let delete_url = "";
                        if(data.is_site_manager) {
                            site_manager_url = `<a href="#" class="assign_location" title="Assign Locations" data-id="${data.id}"><img src="/admin/img/multi-location.svg" /></a>`;
                        }
                        if(!data.is_primary && data.id != adminInfo.id) {
                            delete_url = `<a href="#" class="delete_admin" title="Delete Admin" data-id="${data.id}"><img src="/admin/img/delete.svg" /></a>`;
                        }
                        return `<div class="action-bar">
                                <a href="#" class="update_admin" title="Edit Admin" data-id="${data.id}"><img src="/admin/img/edit.svg" /></a>
                                ${site_manager_url}
                                ${delete_url}                                
                            </div>`;
                    },
                },
            ];
        },
        refreshDataTable() {
            let options = {
                ajax: this.adminAjax,
                scrollY: false,
                scrollX: true,
                dom: '<"top">rt<"bottom"<"left-actions"li>p><"clear">',
                columnDefs: [],
                select: {
                    style: "os",
                    selector: "td:first-child",
                },
                order: [[0, "desc"]],
                columns: this.adminColumns,
            };

            $(".user-datatable").DataTable().destroy();

            $(".user-datatable").DataTable(options).draw();
        },
        viewPage() {
            let vuejs = this;
            $(document).on("click", ".view-admin-details", function(e) {
                e.preventDefault();
                let id = $(this).data("id");
                vuejs.editAdmin(id);
            });
            $(document).on("click", ".delete_admin", function(e) {
                e.preventDefault();
                let id = $(this).data("id");
                vuejs.deleteAdmin(id);
            });
            $(document).on("click", ".update_admin", function(e) {
                e.preventDefault();
                let id = $(this).data("id");
                vuejs.editAdmin(id);
            });
            $(document).on("click", ".assign_location", function(e) {
                e.preventDefault();
                let id = $(this).data("id");
                vuejs.assignLocations(id);
            });
        },
        createAdmin() {
            this.adminForm.clear();
            this.adminForm.reset();
            $("#manageAdminModal").modal("show");
        },
        storeAdmin() {
            let formData = new FormData($("#manageAdminForm")[0]);
            formData.append("token", localStorage.getItem("admin_auth"));
            axios({
                method: "post",
                url: "/api/admin/admins",
                data: formData
            }).then((response) => {
                if (response.data.status) {
                    $("#manageAdminModal").modal("hide");
                    Toast.fire({ icon: 'success', title: response.data.message });
                    this.refreshDataTable();
                    this.errors = false;
                } else {
                    this.errors = response.data.message;

                }
            }, (error) => {
                console.log(error)
            });
        },
        editAdmin(id) {
            this.admin_id = id;
            axios({
                method: "get",
                url: "/api/admin/admins/" + id,
            }).then((response) => {
                this.adminForm.fill(response.data.data);
                $("#manageAdminModalUpdate").modal("show");
            }, (error) => {
                console.log(error)
            });
        },
        updateAdmin(id) {
            let formData = new FormData();
            formData.append("token", localStorage.getItem("admin_auth"));
            formData.append("_method", 'put');
            formData.append("first_name", this.adminForm.first_name);
            formData.append("last_name", this.adminForm.last_name);
            formData.append("phone", this.adminForm.phone);
            formData.append("status", this.adminForm.status);
            formData.append("is_site_manager", this.adminForm.is_site_manager);
            axios({
                method: "post",
                url: `/api/admin/admins/${id}`,
                data: formData
            }).then((response) => {
                if (response.data.status) {
                    $("#manageAdminModalUpdate").modal("hide");
                    Toast.fire({ icon: 'success', title: response.data.message });
                    this.refreshDataTable();
                    this.errors = false;
                } else {
                    this.errors = response.data.message;
                }
            }, (error) => {
                console.log(error)
            });
        },
        deleteAdmin(id) {
            let $this = this;
            $.confirm({
                title: 'Confirmation!',
                content: 'Are you sure to delete this admin?',
                buttons: {
                    confirm: {
                        btnClass: 'btn-red',
                        keys: ['enter'],
                        action: function() {
                            axios({
                                method: "delete",
                                url: `/api/admin/admins/${id}`,
                            }).then((response) => {
                                Toast.fire({ icon: 'success', title: response.data.message });
                                $this.refreshDataTable();
                            }, (error) => {
                                console.log(error)
                            });
                        }
                    },
                    cancel: function() {
                        Toast.fire({ icon: 'success', title: "Cancelled." });
                    }
                }
            });
        },
        assignLocations(id) {
            this.admin_id = id;
            this.getLocations();
            $("#manageLocationsModal").modal("show");
        },
        getLocations() {
            axios.get(`/api/admin/locations/admin/${this.admin_id}`).then(response => {
                this.locations = response.data.data;
            });
        },
        switchLocation(location) {
            axios.get(`/api/admin/admins/${this.admin_id}/manage-location/${location.id}`)
                .then(response => {
                    if(response.data.status) {
                        Toast.fire({ icon: 'success', title: response.data.message });
                    } else {
                        Toast.fire({ icon: 'error', title: response.data.message });
                    }
                    this.getLocations();
                });
        },
    },
    components: {
        FormError
    }

}

</script>
